"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emptyPetDetails = exports.emptyOwnerQuoteDetails = exports.emptyOwnerDetails = exports.PetDetailsPropType = exports.OwnerDetailsQuotePropType = exports.OwnerDetailsPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var PetDetailsPropType = exports.PetDetailsPropType = {
  type: _propTypes["default"].oneOf(['CANINE', 'FELINE']),
  species: _propTypes["default"].oneOf(['Dog', 'Cat', '']),
  petName: _propTypes["default"].string,
  petDOB: _propTypes["default"].string,
  gender: _propTypes["default"].oneOf(['Male', 'Female', '']),
  breed: _propTypes["default"].string,
  desexed: _propTypes["default"].oneOf([1, 0, ''])
};
var OwnerDetailsPropType = exports.OwnerDetailsPropType = {
  name: _propTypes["default"].string,
  email: _propTypes["default"].string.isRequired,
  birthdate: _propTypes["default"].string,
  postcode: _propTypes["default"].string
};
var OwnerDetailsQuotePropType = exports.OwnerDetailsQuotePropType = _objectSpread(_objectSpread({}, OwnerDetailsPropType), {}, {
  promoCode: _propTypes["default"].string,
  membership: _propTypes["default"].string
});
var emptyPetDetails = exports.emptyPetDetails = {
  type: '',
  species: '',
  petName: '',
  petDOB: null,
  gender: '',
  breed: '',
  desexed: ''
};
var emptyOwnerDetails = exports.emptyOwnerDetails = {
  name: '',
  birthdate: '',
  email: '',
  postCode: ''
};
var emptyOwnerQuoteDetails = exports.emptyOwnerQuoteDetails = _objectSpread(_objectSpread({}, emptyOwnerDetails), {}, {
  membership: '',
  promoCode: ''
});